import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const Breadcrumb = ({ items }) => {
  const location = useLocation();
  
  // Schema.org BreadcrumbList structured data
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Accueil",
        "item": "https://sylva-invest.com"
      },
      ...items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 2,
        "name": item.label,
        "item": item.href 
          ? `https://sylva-invest.com${item.href}` 
          : `https://sylva-invest.com${location.pathname}`
      }))
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <nav aria-label="Fil d'Ariane" className="py-4" data-testid="breadcrumb">
        <ol className="flex items-center flex-wrap gap-2 text-sm font-sans">
          <li className="flex items-center">
            <Link 
              to="/" 
              className="text-gray-500 hover:text-forest transition-colors flex items-center"
              aria-label="Accueil"
            >
              <Home className="w-4 h-4" />
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              <ChevronRight className="w-4 h-4 text-gray-400 mx-2" />
              {item.href && index < items.length - 1 ? (
                <Link 
                  to={item.href} 
                  className="text-gray-500 hover:text-forest transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-forest font-medium" aria-current="page">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumb;
